export default __webpack_public_path__ + "static/media/renal-parameters.8d4e6ba0.jpg";